import _ from 'lodash'
import { attackType } from './enums'

const checkValidAttack = (event) => {
  const validAttacks = _.keys(attackType)
  if (!validAttacks.includes(_.toLower(event.key)) && !['Backspace', 'Delete', 'Tab'].includes(event.key)) {
    event.preventDefault()
    return false
  }
  return true
}

const convertScoreToInteger = (score) => {
  if (_.isNil(score)) {
    return 0
  } else if (_.isString(score)) {
    if (_.first(score) === 'V' && score.length > 1) {
      return _.toInteger(_.join(_.slice(score, 1), ''))
    } else if (score === 'V') {
      return score
    } else {
      return _.toInteger(score)
    }
  }

  return score
}

const handleAdvancedPoints = (action, config, playerScore, opponentScore, advanced, isRemove = false) => {
  if (!checkValidAttack({ key: action })) return

  const output = {
    score: _.isNil(playerScore) ? 0 : playerScore,
    advanced
  }

  let current = output.score
  let attack
  if (['Backspace', 'Delete'].includes(action)) {
    if (current === 'V') {
      current = config.score
    } else if (_.first(current) === 'V') {
      current = _.toInteger(current.slice(1))
    }

    let index = current
    if (current >= config.score) index = config.score

    const baseAttack = attackType[_.toLower(advanced[index - 1])]
    attack = {
      value: baseAttack.value
    }
    current += (-1 * baseAttack.value)
    isRemove = true
  } else if (action === 'Tab') {
    return
  } else {
    attack = attackType[_.toLower(action)]
  }

  let victoryScore = config.score
  if (_.first(opponentScore) === 'V' && opponentScore.length > 1) {
    victoryScore = _.toInteger(opponentScore.slice(1))
  }

  if (current + attack.value >= victoryScore && _.first(opponentScore) === 'V') {
    // do nothing
  } else {
    for (let i = 0; i < attack.value; i += 1) {
      if (isRemove) {
        output.advanced[current + i] = null
      } else {
        if (current + i < config.score) {
          if (current + i === config.score - 1) {
            output.advanced[current + i] = _.toUpper(action)
          } else {
            if (i + 1 === attack.value) {
              output.advanced[current + i] = _.toUpper(action)
            } else {
              output.advanced[current + i] = 'x'
            }
          }
        }
      }
    }

    let newScore = output.score
    if (newScore === 'V') {
      newScore = config.score
    } else if (_.first(newScore) === 'V') {
      newScore = _.toInteger(newScore.slice(1))
    }
    if (isRemove) {
      newScore -= attack.value
    } else {
      if (_.first(output.score) !== 'V' && output.score < config.score) {
        newScore += attack.value
      }
    }

    if (newScore >= config.score && _.first(opponentScore) !== 'V') {
      if (newScore === config.score) {
        newScore = 'V'
      } else {
        newScore = `V${newScore}`
      }
    } else if (newScore >= config.score && _.first(opponentScore) === 'V') {
      if (opponentScore.length > 1) {
        newScore = parseInt(opponentScore.slice(1), 10) - 1
      } else {
        newScore = config.score - 1
      }
    }

    output.score = newScore
  }

  return output
}

export {
  checkValidAttack,
  convertScoreToInteger,
  handleAdvancedPoints
}
